import { UseFormRegister } from 'react-hook-form';

import { IContactFormSchema } from '@/src/components/contact-form/useContactForm';
import { IResolvedErrors } from '@/src/utils/collections/errors.mapper';

type IProps = {
  label: string | null;
  register: UseFormRegister<IContactFormSchema>;
  errors: string | null | undefined;
  errorTexts?: IResolvedErrors | null;
};

export const ContactFormCheckbox = ({
  errorTexts,
  label,
  register,
  errors,
}: IProps) => {
  return (
    <div className={'flex items-center justify-center gap-6'}>
      <input
        type={'checkbox'}
        className={'size-7 cursor-pointer bg-white'}
        id={'cgu'}
        {...register('cgu', {
          required: errorTexts?.requiredField || 'Required',
        })}
      />
      <div className={'max-w-48'}>
        <label htmlFor="cgu" className={'text-xs text-gray'}>
          {label}
        </label>
      </div>
      {errors && <span className="text-sm text-red-500">{errors}</span>}
    </div>
  );
};
